import { Check, ContentCopyOutlined } from '@mui/icons-material';
import classnames from 'classnames';
import React from 'react';
import { useCopyToClipboard } from 'new/elements/CodeEditorMode/hooks/useCopyToClipboard';

interface CopyIconButtonProps {
  text: string;
  className?: string;
  copiedClassName?: string;
  title?: string;
  label?: string;
  copiedLabel?: string;
}

export const CopyIconButton = ({
  text,
  className,
  copiedClassName,
  title = 'Copy',
  label,
  copiedLabel,
}: CopyIconButtonProps) => {
  const { isCopied, copyToClipboard } = useCopyToClipboard(text);

  return (
    <button
      type="button"
      className={classnames(className, {
        [copiedClassName!]: isCopied && !!copiedClassName,
      })}
      onClick={(e) => {
        e.stopPropagation();
        copyToClipboard();
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.stopPropagation();
        }
      }}
      title={isCopied ? `${title} - copied` : title}
      aria-label={isCopied ? `${title} - copied` : title}
    >
      {isCopied ? (
        <Check style={{ fontSize: 'var(--font-size-base-sm)' }} />
      ) : (
        <ContentCopyOutlined style={{ fontSize: 'var(--font-size-base-sm)' }} />
      )}
      {label && <span>{isCopied ? (copiedLabel ?? label) : label}</span>}
    </button>
  );
};
